import { render, staticRenderFns } from "./ParentCategory.vue.js?vue&type=template&id=0634c430&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ParentCategory.vue?vue&type=template&id=0634c430&scoped=true"
import script from "./ParentCategory.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ParentCategory.vue?vue&type=script&lang=js"
export * from "./ParentCategory.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ParentCategory.vue?vue&type=script&lang=js"
import style0 from "./ParentCategory.vue.less?vue&type=style&index=0&id=0634c430&prod&lang=less&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ParentCategory.vue?vue&type=style&index=0&id=0634c430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634c430",
  null
  
)

export default component.exports